'use strict';

import { Entity } from '../Entity';

export enum LeadDispo {
  open = 'open',
  closed = 'closed',
  cold = 'cold',
}

export class UserLead extends Entity {
  protected leadId;
  protected leadOrigin;
  protected leadPossession;
  protected leadTransfer;
  protected leadStatus;
  protected leadDispo: LeadDispo;
  protected leadDate;
  protected leadDismiss;
  protected leadFollowup;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.leadId = data.leadId;
    this.leadOrigin = data.leadOrigin;
    this.leadPossession = data.leadPossession;
    this.leadTransfer = data.leadTransfer;
    this.leadStatus = data.leadStatus;
    this.leadDispo = data.leadDispo;

    this.leadDismiss = data.leadDismiss;
    this.leadFollowup = data.leadFollowup;

    if (data.leadDate) {
      const date = data.leadDate['date'].split(' ')[0];
      this.leadDate = date;
    }
  }

  public getLeadId() {
    return this.leadId;
  }

  public getLeadOrigin() {
    return this.leadOrigin;
  }

  public getLeadPossession() {
    return this.leadPossession;
  }

  public getLeadTransfer() {
    return this.leadTransfer;
  }

  public getLeadStatus() {
    return this.leadStatus;
  }

  public getLeadDispo(): LeadDispo {
    return this.leadDispo;
  }

  public getLeadDate() {
    return this.leadDate;
  }

  public getLeadDismiss() {
    return this.leadDismiss;
  }

  public getLeadFollowup() {
    return this.leadFollowup;
  }
}
